import React from "react";
import Image from "next/image";
import styles from "./TrustCard.module.css";

interface TrustCardProps {
  icon?: string;
  iconAlt?: string;
  title: string;
  avatars: {
    src: string;
    alt: string;
    width?: number;
    height?: number;
  }[];
  rating?: {
    starIcon: string;
    starAlt?: string;
    rate: string;
  };
  className?: string;
}

export default function TrustCard({
  icon,
  iconAlt = "Icon",
  title,
  avatars,
  rating,
  className = "",
}: TrustCardProps) {
  return (
    <div className={`${styles['trust-card']} ${className}`}>
      {/* Icon */}
      {icon && (
        <Image
          src={icon}
          alt={iconAlt}
          className={styles.icon} // 1 class duy nhất để responsive
          width={40}
          height={40}
          loading="lazy"
          decoding="async"
        />
      )}

      {/* Title */}
      <p className={styles.title}>{title}</p>

      {/* Avatars và Rating */}
      <div className={styles['rating-group']}>
        <div className={styles['avatar-group']}>
          {avatars.map((avatar, index) => (
            <Image
              key={index}
              className={`${styles.avatar} ${index === 0 ? styles['avatar-first'] : ''}`}
              src={avatar.src}
              alt={avatar.alt}
              width={avatar.width || 32}
              height={avatar.height || 32}
              loading={index === 0 ? "eager" : "lazy"}
              decoding={index === 0 ? "sync" : "async"}
              priority={index === 0}
              fetchPriority={index === 0 ? "high" : "low"}
            />
          ))}
        </div>

        {rating && (
          <div className={styles.rating}>
            <Image
              src={rating.starIcon}
              alt={rating.starAlt || "Ngôi sao đánh giá"}
              className={styles.star}
              width={16}
              height={16}
              loading="lazy"
              decoding="async"
            />
            <span className={styles.rate}>{rating.rate}</span>
          </div>
        )}
      </div>
    </div>
  );
}